<template>
  <div id="components-layout-demo-basic" style="background: #ececec">
    <a-layout>
      <a-layout-header>课后服务开放平台</a-layout-header>
    </a-layout>
    <div class="page-border">
      <div class="group1 content-card">
        <span class="word1" @click="testGetFile">登录账号</span>
      </div>
      <a-card :bordered="false" class="content-card">
        <div style="margin-top: 17px">
          <div class="header">
            <div class="word2">
              请输入注册时使用的主要联络手机号，以完善您的个人信息。
            </div>
            <div class="word3">个人信息会影响后续审核，请认真填写。</div>
            <div class="word2">
              如个人信息已提交审核，登录账号可查询审核结果。
            </div>
          </div>
          <div class="section1 flex-col"></div>
          <a-form :form="form">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item>
                  <div class="title">主要联络手机</div>
                  <a-input
                    v-decorator="[
                      'mobile',
                      {
                        rules: [{ validator: mobileRules }],
                        validateTrigger: 'blur',
                        getValueFromEvent: (event) => {
                          return /^\d+$/.test(event.target.value)
                            ? event.target.value
                            : ''
                        },
                      },
                    ]"
                    placeholder="请输入您常用的手机号" :maxLength="11"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <div class="title">验证码</div>
                <a-form-item
                  :labelCol="{ lg: { span: 1 } }"
                  :wrapperCol="{ lg: { span: 15 } }"
                >
                  <a-col :span="16">
                    <a-input
                      v-decorator="[
                        'password',
                        {
                          rules: [
                            {
                              required: true,
                              pattern: /^\d{6}$/,
                              message: '请输入验证码',
                            },
                          ],
                          getValueFromEvent: (event) => {
                            return /^\d+$/.test(event.target.value)
                              ? event.target.value
                              : ''
                          },
                        },
                      ]"
                      placeholder="请输入收到的验证码" :maxLength="6"
                    />
                  </a-col>
                  <a-col :span="2">
                    <a-button
                      style="margin-left: 20px"
                      @click.stop.prevent="getCode"
                      >{{
                        this.state.time === 0 || this.state.time === 60
                          ? '获取验证码'
                          : `${this.state.time}s后再次发送`
                      }}</a-button
                    >
                  </a-col>
                </a-form-item>
              </a-col>
            </a-row>
            <div class="section4 flex-col"></div>
            <div class="outer9 flex-col"></div>
            <a-form-item>
              <a-button
                class="submit"
                type="primary"
                html-type="submit"
                @click="submit"
                :loading="loading"
              >
                提交
              </a-button>
            </a-form-item>
          </a-form>
        </div>
      </a-card>
    </div>
  </div>
</template>
<script>
import user from '../../api/user'
import bureau from '../../api/bureau'
import teacher from '../../api/teacher'
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      state: {
        time: 60,
      },
      id: '',
      loading: false,
    }
  },
  created() {
    // bureau.getBureauId().then((res) => {
    //   this.id = res
    //   console.log(this.id,'这个id是什么呢?')
    // })
    this.initObtain()
  },
  methods: {
    async initObtain(){
    this.id = null;
      try {
     const res = await bureau.getBureauId()
   if(res){
   this.id = res
   }
   console.log(res,this.id,'then报错的信息是什么')
    
   } catch (err) {
   console.log(err,'catch错误的信息是什么')
   }
   console.log(this.id,'这里面的值是什么1')
   if(!this.id){
      console.log(this.id,'这里面的值是什么2')
      this.$router.push('/portal')
    }
    },
    //手机号自定义校验
    mobileRules(rule, value, callback) {
      if (!value) {
        callback('请输入常用的手机号')
      } else if (!/^[\u0030-\u0039]{11}$/.test(value)) {
        callback('请输入正确的手机号')
      }
      callback()
    },
    //获取验证码
    getCode(e) {
      e.preventDefault()
      this.form.validateFields(['mobile'], (err, values) => {
        if (!err) {
          if (60 > this.state.time > 0) {
            return
          }
          const hide = this.$message.loading('验证码发送中..', 0)
          teacher
            .loginGetCode(values.mobile)
            .then((res) => {
              setTimeout(hide, 2500)
            })
            .catch((err) => {
              console.error('错误信息：', err)
              setTimeout(hide, 1)
              clearInterval(interval)
              this.state.time = 60
            })
          let timerId
          //发送请求，获取验证码
          timerId = window.setInterval(() => {
            this.state.time -= 1
            if (this.state.time === 0) {
              clearInterval(timerId)
              this.state.time = 60
            }
          }, 1000)
        } else {
          this.$refs.input.focus()
          return
        }
      })
    },
    //提交
    submit() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true
          var _this = this;
          await teacher.loginByCode({ ...values }).then(async (res) => {
            this.$ls.set('token', res.accessToken.accessToken)

            await teacher.getMyself().then((res) => {
              console.log('res', res)
              this.$store.commit('register/changeInformation', res.data)

              //待提交和审核不通过跳转至修改页面
              if (res.data.status === 2 || res.data.status === 3) {
                this.$router.push('/teacherReviewChange')
                return
              }
              //待审核，初审通过，复审通过，审核通过，跳转至查看页面
              else if (
                res.data.status === 0 ||
                res.data.status === 1 ||
                res.data.status === 4 ||
                res.data.status === 5
              ) {
                this.$router.push('/teacherReview')
                return
              }
              this.loading = false
            })
          }).catch(reason => {
            _this.loading = false
          })
        }
      })
    },
    testGetFile() {
      //teacher.getFile();
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1280px) {
  div.page-border {
    padding-top: 108px;
    height: 100%;
  }
}

@media screen and  (max-width: 1280px) {
  div.page-border {
    padding-top: 28px;
    padding-right: 10px;
    padding-left: 10px;
    height: 100%;
  }  
}
div.page-border {
  background: #ececec;
}
.content-card {
  max-width: 1080px;
  min-width: 800px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

#components-layout-demo-basic {
  text-align: left;
  height: 100vh;
  overflow: auto;
}
#components-layout-demo-basic .ant-layout-header {
  background: #0b0b0f;
  color: #ffffff;
  font-size: 24px;
}
.ant-card {
  border-radius: 20px;
}
.group1 {
  height: 40px;
  padding-left: 30px;
}

.word1 {
  font-size: 24px;
  color: rgba(27, 29, 38, 1);
  line-height: 22px;
}

.word2 {
  font-size: 20px;
  color: rgba(27, 29, 38, 1);
}
.word3 {
  height: 22px;
  display: inline-block;
  color: rgba(27, 29, 38, 1);
  font-size: 20px;
  margin-bottom: 20px;
}
.header {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  margin: 16px 0 0 0;
  .word2 {
    margin-bottom: 10px;
  }
}
.section1 {
  height: 4px;
  background-color: rgba(235, 241, 253, 1);
  margin-top: 31px;
}
.title {
  font-size: 16px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  margin-top: 100px;
}

.section4 {
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
  margin-top: 100px;
}
.submit {
  width: 140px;
  height: 42px;
  left: 45%;
  margin-top: 20px;
}
</style>
